import { ExportContent } from '../components/Export/ExportContent.component';

export const Export: React.FC = () => {
  return <ExportContent />;
};
